import React from 'react'
import { MdOutlineFileUpload } from 'react-icons/md'
import { SessionManager } from '../../utils'

export default function ActionUpload(props) {

    const { text, route_name, onClick } = props

    const permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <MdOutlineFileUpload
                    size={17}
                    className="action-button text-primary me-3"
                    onClick={onClick}
                    data-tooltip-id="global-table-tooltip"
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name="bg-info tooltip_msg"
                />
            }
        </>
    )
}
